import { render, staticRenderFns } from "./OTVencidas.vue?vue&type=template&id=404c1498&"
import script from "./OTVencidas.vue?vue&type=script&lang=js&"
export * from "./OTVencidas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports